export function LabAccountIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" className="size-3.5" {...props}>
      <circle cx="6.999" cy="5.056" r="1.944" stroke="currentColor" strokeWidth=".778" />
      <path stroke="currentColor" strokeWidth=".778" d="M10.11 10.5c0-1.556-1.555-2.722-3.11-2.722-1.556 0-3.111 1.166-3.111 2.722M10.11 10.5v.778H3.89V10.5" />
    </svg>
  );
}
